// extracted by mini-css-extract-plugin
export default {"invoiceSummary":"u8M13aUO--styles_invoiceSummary__1oZu4","shimmer":"u8M13aUO--styles_shimmer__d5823"};